module.exports = "<div class=\"ivu-col ivu-col-span-17\">\r\n    install works!\t\t\t\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/view/install/install.component.html
// module id = ./src/app/view/install/install.component.html
// module chunks = main